import { Box } from "@mui/system";
import { SectionTitle, StyledOneChildContainer, StyledParentContainer, StyledTwoChildContainer } from "../../StyledComponents/Container"
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import Grid from "@mui/material/Grid2";
import { Backdrop, CircularProgress, InputAdornment, Typography } from "@mui/material";
import { useState } from "react";
import CancelPopUp from "../../../PopUp/PopUp";
import SubmitPopUp from "../../../PopUp/PopUp";
import EditIcon from '@mui/icons-material/Edit';
import { useTranslation } from "react-i18next";
import ContainedButton from "../../../../shared/Button/CustomContainedButton";
import OutlinedButton from "../../../../shared/Button/customOutlinedButton";
import * as constants from "../../../../constants";
import CustomTextField from "../../../../shared/CustomTextFeild";
import { saveMakePaymentDetails } from "../../services/RCBOInvoices/RCBOInvoiceServices";
import { notifyUser } from "../../Utils/notifyUser";
import { setRefreshCountFlag } from "../../../../store/Invoice/invoiceCountSlice";

const convertDateToISOString = (dateStr: string, hours: number = 7, minutes: number = 0): string => {
    // Convert the date string to a Date object
    const dateObj = new Date(dateStr);

    // Set the specific hours and minutes (default is 07:00:00)
    dateObj.setHours(hours, minutes, 0, 0);

    // Return the date as an ISO string in UTC format
    return dateObj.toISOString();
};

const formatDate = (dateString: string): string => {
    const [year, month, day] = dateString.split('-');
    return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
};

const PaymentReviewAndSubmit = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const translate = t as (key: string) => string;
    const userInfo = useSelector((state: RootState) => state.auth);
    const formData = location.state;
    const [openPopUp, setOpenPopUp] = useState(false);
    const [open, setOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleCancel = () => {
        setOpenPopUp(true);
    };
    const handlePopUpClose = () => {
        setOpenPopUp(false);
    };
    function handleConfirm() {
        dispatch(setRefreshCountFlag(true));
        navigate("/rcboInvoiceSummaryListing");
    }
    function handleBackClick() {
        navigate("/rcboInvoicePayment", { state: { submitData: formData } });
    }
    const handleSubmitClose = () => {
        setOpen(false);
    };
    const saveSubmitChanges = () => {
        setOpen(true);
    };

    const handleSave = async () => {
        if (isLoading) {
            return;
        }

        setOpen(false);
        setIsLoading(true);
        try {
            const saveVo = {
                participantId: userInfo.defaultParticipantId,
                clientId: userInfo.clientId,
                invoiceNumber: formData.invoiceNumber,
                postDescription: formData.postingDescription,
                netsuiteInvoiceNumber: formData.netsuiteInvoiceNumber,
                invoiceMakePaymentVO: {
                    refId: 0,
                    otherAmountToPaid: formData.OtherpaymentAmount ? Number(formData.OtherpaymentAmount) : 0,
                    amountSelection: false,
                    selectedFundId: formData.source?.id,
                    sourceName: formData.source?.name,
                    availableBalance: formData.source?.availableBalance,
                    creditLineSrcId: 0,
                    fundSrcId: formData.source?.name != "Checking" ? formData.source?.id : 0,
                    cashSrcId: formData.source?.name === "Checking" ? formData.source?.id : 0,
                    balanceAmount: formData.OtherpaymentAmount ? Number(formData.OtherpaymentAmount) : formData.outstandingBalance ? Number(formData.outstandingBalance.replace(/[^0-9.]/g, '')) : 0
                },
                invoiceTransactionHistory: [
                    {
                        balance: parseFloat(formData.outstandingBalance.replace('$', '')) - formData.OtherpaymentAmount,
                        feePayment: 0,
                        interestPayment: 0,
                        principalPayment: Number(formData.OtherpaymentAmount),
                        createdBy: userInfo.emailId,
                        lastUpdatedBy: userInfo.emailId,
                        postingDate: convertDateToISOString(formData.invoiceDate)
                    }
                ]
            }
            const response = await saveMakePaymentDetails(saveVo);
            if (response.status === constants.STATUS_CODES.SUCCESS) {
                const message = response.data.message;
                dispatch(setRefreshCountFlag(true));
                navigate("/rcboInvoiceSummaryListing", { state: { message: message } });
            } else {
                notifyUser(response.response.data.message, 'error', translate('review&Submit'));
            }
        } catch (error) {
            console.error("Error saving AutoDebit details:", error);
        } finally {
            setIsLoading(false);
        }
    }
    return (
        <StyledParentContainer>
            <StyledOneChildContainer>
                <StyledTwoChildContainer sx={{ border: "none" }}>
                    <SectionTitle> {translate('review&Submit')}&nbsp;<EditIcon sx={{ cursor: 'pointer' }} onClick={handleBackClick} /></SectionTitle>

                    <StyledTwoChildContainer>
                        <Box sx={{ padding: "40px" }}>
                            <Grid container spacing={2} direction={'column'}>
                                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                    <CustomTextField labelText={translate('invoiceNumber')} value={formData?.invoiceNumber} readOnly />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                    <CustomTextField labelText={translate('source')} value={formData?.source.name} readOnly />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                    <CustomTextField
                                        labelText={translate('newInvoiceBalance')}
                                        value={
                                            new Intl.NumberFormat('en-US', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            }).format(
                                                parseFloat(formData.outstandingBalance.replace(/[$,]/g, "")) -
                                                (
                                                    (formData.OtherpaymentAmount ?? 0) == 0
                                                        ? parseFloat(formData.outstandingBalance.replace(/[$,]/g, ""))
                                                        : parseFloat(formData.OtherpaymentAmount ?? 0)
                                                )
                                            )
                                        }
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                        }}
                                        readOnly
                                    />

                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                    <CustomTextField
                                        labelText={translate('amountPaid')}
                                        value={
                                            new Intl.NumberFormat('en-US', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            }).format((formData.OtherpaymentAmount ?? 0) == 0
                                                ? parseFloat(formData.outstandingBalance.replace(/[$,]/g, ""))
                                                : parseFloat(formData.OtherpaymentAmount ?? 0)
                                            )}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                        }}
                                        readOnly
                                    />

                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>
                                    <CustomTextField labelText={translate('paymentDate')} value={formatDate(formData?.paymentDate)} readOnly />
                                </Grid>
                            </Grid>
                        </Box>
                    </StyledTwoChildContainer>
                    <div className="right-fields" style={{ marginTop: '10px' }}>
                        <ContainedButton sx={{ mr: 2 }} onClick={saveSubmitChanges}>{translate('submit')}</ContainedButton>
                        <ContainedButton sx={{ mr: 2 }} onClick={handleBackClick}>{translate('back')}</ContainedButton>
                        <OutlinedButton onClick={handleCancel}>{translate('cancel')}</OutlinedButton>
                    </div>
                    <SubmitPopUp
                        open={open}
                        popupTitle={translate('confirmSubmit')}
                        handleClose={handleSubmitClose}
                        saveChanges={() => handleSave()}
                        message={translate('doYouWantToSubmitChanges?')}
                    />
                    <CancelPopUp
                        open={openPopUp}
                        popupTitle={translate('confirmCancel')}
                        handleClose={handlePopUpClose}
                        saveChanges={() => handleConfirm()}
                        message={translate('doYouWantToCancelChanges?')}
                    />
                    <Backdrop
                        sx={(theme) => ({
                            color: "#fff",
                            zIndex: theme.zIndex.drawer + 1,
                            display: "flex",
                            flexDirection: "column",
                        })}
                        open={isLoading}
                    >
                        <CircularProgress color="inherit" />
                        <Typography color="white">Please wait...</Typography>
                    </Backdrop>
                </StyledTwoChildContainer>
            </StyledOneChildContainer>
        </StyledParentContainer>
    )
}
export default PaymentReviewAndSubmit;